import React, { useEffect, useMemo, useState } from 'react';
import { GUN_KISA, tarihStr, gunEkle, tarihOku } from './randevuOrtak';
import '../takip/takip.css';
import './randevu.css';

// v1.24.0 — Sunum / teklif müşteri portalı: müşteri temsilcisinin takvimi online randevuya açıksa müşteri buradan randevu alır.
const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5159';

interface Bilgi {
    acik: boolean;
    temsilci?: string;
    turler?: { turID: number; ad: string; varsayilanSure: number; renk: string; ikon?: string | null }[];
    ilkGun?: string;
    sonGun?: string;
    yaklasan?: { baslangic: string; baslik: string; musteriToken: string } | null;
}

const PortalRandevu: React.FC<{ linkToken: string }> = ({ linkToken }) => {
    const [bilgi, setBilgi] = useState<Bilgi | null>(null);
    const [acik, setAcik] = useState(false);
    const [turID, setTurID] = useState<number | null>(null);
    const [gun, setGun] = useState('');
    const [saatler, setSaatler] = useState<string[] | null>(null);
    const [saat, setSaat] = useState('');
    const [not, setNot] = useState('');
    const [hata, setHata] = useState('');
    const [gonderiliyor, setGonderiliyor] = useState(false);

    const yukle = () => fetch(`${API_BASE}/api/RandevuPortal/portal/${linkToken}`).then(r => r.json()).then(d => {
        setBilgi(d);
        if (d.turler?.length === 1) setTurID(d.turler[0].turID);
        if (d.ilkGun) setGun(d.ilkGun);
    }).catch(() => setBilgi({ acik: false }));
    useEffect(() => { yukle(); /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, [linkToken]);

    const gunler = useMemo(() => {
        if (!bilgi?.ilkGun || !bilgi?.sonGun) return [] as Date[];
        const l: Date[] = [];
        for (let d = new Date(bilgi.ilkGun + 'T00:00:00'); tarihStr(d) <= bilgi.sonGun && l.length < 60; d = gunEkle(d, 1)) l.push(d);
        return l;
    }, [bilgi?.ilkGun, bilgi?.sonGun]);

    useEffect(() => {
        if (!acik || !gun || !turID) { setSaatler(null); return; }
        setSaatler(null); setSaat('');
        fetch(`${API_BASE}/api/RandevuPortal/portal/${linkToken}/saatler?gun=${gun}&turID=${turID}`)
            .then(r => r.json()).then(d => setSaatler(Array.isArray(d) ? d : [])).catch(() => setSaatler([]));
    }, [acik, gun, turID, linkToken]);

    const gonder = async () => {
        setGonderiliyor(true); setHata('');
        try {
            const r = await fetch(`${API_BASE}/api/RandevuPortal/portal/${linkToken}`, {
                method: 'POST', headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ turID, baslangic: `${gun}T${saat}:00`, not: not || null }),
            });
            const d = await r.json();
            if (!r.ok) { setHata(d.message || 'Randevu alınamadı.'); if (r.status === 409) { setSaat(''); setGun(g => g); } return; }
            window.location.href = `/randevu/${d.musteriToken}`;
        } catch { setHata('Bağlantı hatası.'); }
        finally { setGonderiliyor(false); }
    };

    if (!bilgi?.acik) return null;
    const tur = bilgi.turler?.find(t => t.turID === turID);

    return (
        <>
            <div style={{ background: 'linear-gradient(135deg, #0f766e 0%, #0d9488 100%)', color: '#fff', padding: '12px 24px', display: 'flex', alignItems: 'center', gap: 14, flexWrap: 'wrap' }}>
                <i className="fas fa-calendar-check" style={{ fontSize: 20 }}></i>
                <div style={{ flex: 1, minWidth: 200 }}>
                    {bilgi.yaklasan ? (
                        <>
                            <div style={{ fontWeight: 700, fontSize: 14 }}>Randevunuz: {tarihOku(bilgi.yaklasan.baslangic).toLocaleString('tr-TR', { weekday: 'long', day: 'numeric', month: 'long', hour: '2-digit', minute: '2-digit' })}</div>
                            <div style={{ fontSize: 12.5, opacity: 0.85 }}>Temsilciniz {bilgi.temsilci} · görüntüleyin, değiştirin ya da iptal edin</div>
                        </>
                    ) : (
                        <>
                            <div style={{ fontWeight: 700, fontSize: 14 }}>Temsilciniz {bilgi.temsilci} ile görüşmek ister misiniz?</div>
                            <div style={{ fontSize: 12.5, opacity: 0.85 }}>Müsait saatlerden size uygun olanı seçerek randevu alın.</div>
                        </>
                    )}
                </div>
                {bilgi.yaklasan
                    ? <a href={`/randevu/${bilgi.yaklasan.musteriToken}`} style={{ background: '#fff', color: '#0f766e', borderRadius: 8, padding: '8px 16px', fontWeight: 700, fontSize: 13, textDecoration: 'none' }}>Randevuyu görüntüle</a>
                    : <button onClick={() => setAcik(true)} style={{ background: '#fff', color: '#0f766e', border: 'none', borderRadius: 8, padding: '8px 16px', fontWeight: 700, fontSize: 13, cursor: 'pointer' }}>Randevu al</button>}
            </div>

            {acik && (
                <div className="tkp-perde" onMouseDown={e => { if (e.target === e.currentTarget) setAcik(false); }}>
                    <div className="tkp-modal dar">
                        <div className="tkp-modal-bas" style={{ background: '#0f766e' }}>
                            <i className="fas fa-calendar-plus"></i><h5>Randevu al — {bilgi.temsilci}</h5>
                            <button className="tkp-kapat" onClick={() => setAcik(false)}>×</button>
                        </div>
                        <div className="tkp-modal-govde">
                            {hata && <div className="tkp-hata">{hata}</div>}
                            <div className="rnd-adim" style={{ marginTop: 0 }}>Görüşme konusu</div>
                            <div className="rnd-secim">
                                {bilgi.turler?.map(t => (
                                    <button key={t.turID} className={turID === t.turID ? 'aktif' : ''} onClick={() => setTurID(t.turID)}>
                                        <i className={`fas ${t.ikon || 'fa-calendar'}`} style={{ color: t.renk }}></i>{t.ad}<span style={{ fontSize: 11, color: '#94a3b8' }}>{t.varsayilanSure} dk</span>
                                    </button>
                                ))}
                            </div>
                            {turID && (
                                <>
                                    <div className="rnd-adim">Gün</div>
                                    <div className="rnd-gun-serit">
                                        {gunler.map(d => (
                                            <button key={tarihStr(d)} className={gun === tarihStr(d) ? 'aktif' : ''} onClick={() => setGun(tarihStr(d))}>
                                                <div className="g">{GUN_KISA[d.getDay()]}</div><div className="n">{d.getDate()}</div><div className="a">{d.toLocaleDateString('tr-TR', { month: 'short' })}</div>
                                            </button>
                                        ))}
                                    </div>
                                    <div className="rnd-adim">Saat</div>
                                    {saatler === null && <div className="tkp-bos"><i className="fas fa-spinner fa-spin"></i></div>}
                                    {saatler && saatler.length === 0 && <div className="tkp-bos">Bu gün için boş saat yok, başka bir gün seçin.</div>}
                                    {saatler && saatler.length > 0 && <div className="rnd-secim">{saatler.map(s => <button key={s} className={saat === s ? 'aktif' : ''} onClick={() => setSaat(s)}>{s}</button>)}</div>}
                                </>
                            )}
                            {saat && (
                                <>
                                    <div className="rnd-adim">Not (isteğe bağlı)</div>
                                    <textarea className="tkp-girdi" rows={2} value={not} maxLength={1000} onChange={e => setNot(e.target.value)} placeholder="Görüşmek istediğiniz konu" />
                                </>
                            )}
                        </div>
                        <div className="tkp-modal-alt">
                            <button className="tkp-btn" onClick={() => setAcik(false)}>Vazgeç</button>
                            <button className="tkp-btn turuncu" disabled={!saat || gonderiliyor} onClick={gonder}>
                                <i className={`fas ${gonderiliyor ? 'fa-spinner fa-spin' : 'fa-check'}`}></i>
                                {saat ? `${new Date(gun + 'T00:00:00').toLocaleDateString('tr-TR', { day: 'numeric', month: 'long' })} ${saat} · ${tur?.ad ?? ''}` : 'Saat seçin'}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default PortalRandevu;
